// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabs-skeleton[data-v-4462031e]{width:46rem;height:3rem}.buttons-skeleton[data-v-4462031e]{width:30rem;height:3em}.table-skeleton[data-v-4462031e]{height:40rem}", ""]);
// Exports
module.exports = exports;
